import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Text',
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const style = computed(() => {
  const result: {[key: string]: any} = {};
  if (props.block.textColor) {
    result.color = props.block.textColor;
  }
  if (props.block.padding) {
    result.padding = props.block.padding;
  }
  if (props.block.textAlign) {
    result.textAlign = props.block.textAlign;
  }
  if (props.block.maxWidth) {
    result.maxWidth = props.block.maxWidth;
  }

  if (props.block.sticky) {
    result.position = 'sticky';
    result.top = '101px';
  }

  return result;
});

return (_ctx: any,_cache: any) => {
  const _component_rich_text = _resolveComponent("rich-text")!

  return (_openBlock(), _createBlock(_component_rich_text, {
    class: "text__style-container",
    value: __props.block.body,
    style: _normalizeStyle(_unref(style))
  }, null, 8, ["value", "style"]))
}
}

})